<template>
    <div class="compary">
		<div class="page-tit">
			<span>{{ queryData.id ? '文章编辑' : '文章新增' }}</span>
            <el-button style="float: right; margin-top: 10px;" type="primary" size="mini" @click="$router.push({name: 'siteNetworkList'})">返回列表</el-button>
		</div>
		<div class="compary-con siteset-mian">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="98px" class="demo-ruleForm yq">
                <el-form-item label="文章标题" prop="prodTitle">
					<el-input v-model="ruleForm.prodTitle" placeholder="请输入文章标题" ref="prodTitle"></el-input>
				</el-form-item>
                <el-form-item label="网页关键词" prop="keywords">
					<el-input v-model="ruleForm.keywords" placeholder="请输入网页关键词" ref="keywords"></el-input>
				</el-form-item>
				<el-form-item label="网页描述" prop="prodDesc">
					<el-input type="textarea" :autosize="{ minRows: 7, maxRows: 7}" v-model="ruleForm.prodDesc" placeholder="请输入网页描述" ref="prodDesc"></el-input>
				</el-form-item>
				<el-form-item label="文章缩略图" class="edit-form edit-upload" prop="enterpriseLogoUrl">
					<div class="upload">
						<el-upload class="avatar-uploade" action="https://jsonplaceholder.typicode.com/posts/" :http-request="customUpload" :multiple="false" :show-file-list="false">
							<img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar" />
							<i v-else class="icon i-upload"></i>
						</el-upload>
					</div>
					<div style="display: inline-block;" class="upload-txt">
						<div style="padding-left: 8px;">
                            (请上传jpg或png格式的图片)
                        </div>
					</div>
					<el-input type="hidden" v-model="ruleForm.imgUrl"></el-input>
				</el-form-item>
				<el-form-item label="文章详情" prop="prodDetails">
                    <div class="AIIMAGES" @click="editContentFn()"><em style="font-size: 16px;" class="el-icon-picture-outline"></em> AI配图</div>

                    <!-- <el-input type="textarea" :autosize="{ minRows: 30, maxRows: 30}" v-model="ruleForm.prodDetails" placeholder="请输入文章详情" ref="prodDetails"></el-input> -->
                     <div style="border: 1px solid #ccc; z-index: 9999;">
                        <Toolbar style="border-bottom: 1px solid #ccc"
                            :editor="editor"
                            :defaultConfig="toolbarConfig"
                            :mode="mode"
                        />
                        <Editor style="height: 500px; overflow-y: hidden;"
                            ref="EditorMain"
                            v-model="ruleForm.prodDetails"
                            :defaultConfig="editorConfig"
                            :mode="mode"
                            @onCreated="onCreated"
                        />
                    </div>
				</el-form-item>
                <h2 class="form-infos"></h2>
                <el-form-item label="选项" prop="options">
                    <el-checkbox-group v-model="ruleForm.options">
                        <el-checkbox style="margin-right: 33px;" label="推荐"></el-checkbox>
                        <el-checkbox style="margin-right: 33px;" label="置顶"></el-checkbox>
                    </el-checkbox-group>
				</el-form-item>
                <el-form-item label="显示" prop="show">
                    <el-radio v-model="ruleForm.show" label="0">显示</el-radio>
                    <el-radio v-model="ruleForm.show" label="1">隐藏</el-radio>
				</el-form-item>
                <el-form-item label="时间" prop="releaseTime">
					<el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-model="ruleForm.releaseTime"
                        type="datetime"
                        placeholder="选择日期时间"
                    />
				</el-form-item>
                <el-form-item label="来源" prop="source">
                    <el-radio v-model="ruleForm.source" label="YC">原创</el-radio>
                    <el-radio v-model="ruleForm.source" label="ZQ">抓取</el-radio>
                    <el-radio v-model="ruleForm.source" label="QT">其他</el-radio>
				</el-form-item>
                <el-form-item label="文章类型" prop="userName">
                    <el-input v-model="ruleForm.userName" placeholder="请输入文章类型"></el-input>
				</el-form-item>
			</el-form>
			<div class="formbtn ani" @click="submitForm()">保存</div>
			<ImgCropper v-if="showCropper" :newFileName="newFileName" :showCropper="showCropper" :aRation="4/3" @closeCrop="closeCrop" :cropOptions="cropOptions"></ImgCropper>
			<!-- 提示 -->
			<!-- <yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint> -->
		</div>
        <AiImageDialog ref="aiImageDialog" @onFileChange="onFileChange" :wSize="0" :hSize="0" />
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import SiteApi from '@/api/site.api'
import mixinDialog from '@/mixins/mixinsDialog'
 import moment from "moment";
import ImgCropper from '../Template/edit-template/component/ImgCroppre'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import AiImageDialog from './AiImageDialog.vue'

export default {
    name: 'siteAddContent',
    components: {
        ImgCropper, Editor, Toolbar, AiImageDialog
    },
    data() {
        return {
            queryData: null,
            ruleForm: {
                prodTitle: '',
                imgUrl: '',
                prodDetails: '',
                keywords: '',
                prodDesc: '',
                source: 'YC',
                show: '0',
                options: [],
            },
            rules: {
                prodTitle: [
                    { required: true, message: '请输入文章标题', trigger: 'blur' }
                ],
                prodDetails: [
                    { required: true, message: '请输入文章详情', trigger: 'blur' }
                ],
                keywords: [
                    { required: true, message: '请输入网页关键词', trigger: 'blur' }
                ],
                prodDesc: [
                    { required: true, message: '请输入网页描述', trigger: 'blur' }
                ],
            },
            showCropper: false,

            // 富文本相关参数
            editor: null,
            toolbarConfig: {
                excludeKeys: ['uploadImage', 'uploadVideo', 'emotion']	// 配置排除的富文本功能
            },
            editorConfig: { placeholder: '请输入内容...' },
            mode: 'default', // or 'simple'
        }
    },
    methods: {
        ...mapActions('user', [
			'getEnterpriseInfo',
		]),
        // 获取详情
        getDetailFn(id) {
            SiteApi.getDetail(id).then(res => {
                console.log(res.data)
                if (res.data.isSuccess) {
                    Object.assign(this.ruleForm, res.data.data)
                } else {
                    this.$message.error('获取文章详情失败，请稍后重试')
                }
            })
        },
        // 富文本编辑器
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },


        /////////////////////// 图片上传 ///////////////////////
        getNewFileName (file) {
			let fileExtName = /\.[^\.]+$/.exec(file.name)[0]
			let imgName = fileExtName === '.ico' ? 'favicon' : new Date().getTime()
			this.newFileName = `images/siteNetwork/${imgName}${fileExtName}`
		},
        closeCrop (val) {
			this.showCropper = false
			this.ruleForm.imgUrl = val
		},
        customUpload (fielObj) {
			let file = fielObj.file
			if (!/(image\/jpeg)|(image\/png)/.test(file.type)) {
				this.openErrDialog('warn', '操作信息提示', '', '', '必需为png或jpg图片类型', '确定')
				return
			}
			// 大小不允许超过30M
			let imgSize = file.size
			if (imgSize > 30 * 1024 * 1024) {
				this.openImgErrDialog('warn', '操作信息提示', '', '', '图片大小不能大于30M', '确定')
				return
			}
			this.getNewFileName(file)
			if (typeof FileReader === 'function') {
				const reader = new FileReader()
				reader.onload = (e) => {
					let base64 = e.target.result
					let upImage = new Image()
					upImage.src = base64
					upImage.onload = () => {
						this.cropOptions = {
							cropLawImg: base64,
							upImageHeight: upImage.height,
							upImageWidth: upImage.width,
							wSize: upImage.height,
							hSize: upImage.width,
							file: file,
							islogo: false,
							fname: file.name
						}
						this.showCropper = true
					}
				}
				reader.readAsDataURL(file)
			} else {
				this.openErrDialog('warn', '操作信息提示', '', '', '浏览器不支持，请更换浏览器后重试', '确定')
			}
		},
        /////////////////////// 提交 ///////////////////////
        submitForm() {
            console.log(this.ruleForm)
            this.ruleForm.title = this.ruleForm.prodTitle
            this.ruleForm.companyId = this.enterpriseData.enterpriseId
            this.ruleForm.company = this.enterpriseData.enterpriseName

            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const api = this.queryData.id ? 'editSiteArticle' : 'addSiteArticle'
                    SiteApi[api](this.ruleForm).then(res => {
                        if (res.data && res.data.isSuccess) {
                            this.$message.success(res.data.message || '保存成功')
                            this.$router.push({
                                name: 'siteNetworkList'
                            })
                        } else {
                            this.$message.error(res.data.message || '保存失败，请稍后重试')
                        }
                    })
                } else {
                    console.log('校验失败')
                }
            })
        },
        //获取公司信息
		getInfos () {
			this.getEnterpriseInfo().then(res => {
				if (res.data.isSuccess) {
					const data = res.data.data
                this.enterpriseData = data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					})
				}
                this.getListFn(1)
			})
		},
        editContentFn() {
            this.$refs.aiImageDialog.initFn('')
        },
        // 图片上传成功
        onFileChange(data) {
            if (data.thumbnail) return this.ruleForm.imgUrl = data.urlFile
            if (this.ruleForm.prodDetails.indexOf('</p><p>') !== -1) {
                this.ruleForm.prodDetails = this.ruleForm.prodDetails.replace('</p><p>', `</p><br/><p><img src="${ data.urlFile }" /><p><br/><p>`)
            } else {
                this.ruleForm.prodDetails += `</p><br/><p><img src="${ data.urlFile }" /><p><br/><p>`
            }
        },
    },
    created () {
        this.queryData = this.$route.query
        if (this.queryData.id) {
            this.getDetailFn(this.queryData.id)
        } else {
            // 默认当前时间
            this.ruleForm.releaseTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        }
        this.getInfos()
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<style lang="scss" scoped>
    .edit-form {
        position: relative;
        width: 685px;
        margin-bottom: 29px;
        label {
            display: inline-block;
            width: 98px;
            text-align: right;
            padding-right: 12px;
        }
    }
    .compary-con{
        background:rgba(255,255,255,1);
        border-radius:4px;
        padding: 34px 70px;

    }

    .form-infos {
        border-top: 1px solid #CAD2ED;
        margin-top: 49px;
        padding-top: 24px;
        color: $colorD;
        font-size: 14px;
        font-weight: normal;
        line-height: 14px;
    }

    .formbtn {
        margin: 30px 0 44px 98px;
    }

    .upload {
        position: relative;
        display: inline-block;
        width: 120px;
        height: 120px;
        border-radius:8px;
        border: 1px dashed #A1ABD5;
        border-radius: 3px;
        vertical-align: top;
        cursor: pointer;

        i {
            display: block !important;
            margin: 40px auto 0 !important;
        }
    }

    .upload-txt{
        span{font-size: 12px;
        color: #8392A4;}
    }
    .edit-upload {
        font-size: 0;

        label {
            line-height: 40px;
            vertical-align: top;
            font-size: 14px;
        }

        i {
            line-height: 120px;
        }
    }

    .el-input {
        width: 420px;
    }

    .el-select {
        display: inline-block;
        width: 420px;
    }

    i.must {
        display: inline-block;
        margin-left: 20px;
        color: #e80000;
        font-size: 14px;
    }

    .avatar-uploader {
        display: inline-block;
        position: relative;
        width: 95px;
        height: 95px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        vertical-align: top;
        cursor: pointer;
        overflow: hidden;

        i {
            display: block !important;
            margin: 28px auto 0 !important;
        }

        &.err {
            border: 1px solid #f56c6c;
        }
    }

    .avatar {
        max-width: 93px;
        max-height: 93px;
        display: inline-block;
        vertical-align: middle;
    }

    .el-form-item__error {
        left: 88px;
    }
    .AIIMAGES{
        position: absolute; right: 0; top: -50px;
        cursor: pointer;
        background: linear-gradient(90deg, #12026e, #12026e, #f00, #66f, #f66);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
</style>
<style>
    .compary .el-input__icon{
        line-height: 32px;
    }
</style>
